import { BreakPointCondition, useBreakpointIf, VStack } from '@genial/components';
import { DrawerScreenProps } from '@react-navigation/drawer';
import { View } from 'native-base';
import React, { useCallback } from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { useRecoilQuery } from '../../../hooks/useRecoilQuery';
import { SignedInRootStackParamList } from '../../../routes/types';
import { subscriptionMarketStatusQuery } from '../../../store/subscription/selector';
import { SubscriptionSmallCard } from '../components/SubscriptionSmallCard';

import { SubscriptionDetailsHeader } from './components/SubscriptionDetailsHeader';
import { SubscriptionDetailsTabs } from './components/SubscriptionDetailsTabs';

const styles = StyleSheet.create({
  contentComponentStyle: { flex: 1 },
});

export const SubscriptionDetails: React.FC<
  DrawerScreenProps<SignedInRootStackParamList, 'SubscriptionDetails'>
> = ({ navigation, route }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  useRecoilQuery(subscriptionMarketStatusQuery);

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
    return navigation.navigate('Subscription');
  }, [navigation]);

  return (
    <ScrollView style={styles.contentComponentStyle} showsHorizontalScrollIndicator={false}>
      <View
        p="inset.xs"
        flex={1}
        width="full"
        maxWidth={{ base: '100%', sm: '95%', lg: '1280px' }}
        minWidth={0}>
        <VStack space={isMobile ? 'stack.xxxs' : 'stack.xxs'} flex={1} width="full">
          <SubscriptionDetailsHeader isMobile={isMobile} onReturn={goBack} />
          <SubscriptionSmallCard subscription={route.params.subscription} />
          <SubscriptionDetailsTabs isMobile={isMobile} params={route.params} />
        </VStack>
      </View>
    </ScrollView>
  );
};
